import { AuxiliumComponent } from "../auxilium-component";

export default class TabGroup extends AuxiliumComponent {
	static observable = ["orientation", "direction", "variation"];
	static observableBooleans = ["is-dynamic", "scroll", "prevent-buttons", "skip-validation", "hide-tabs"];

	constructor() {
		super();

		this.selectedIndex = 0;
	}

	parsedCallback() {
		const allTabs = this.GetAllTabs(),
			firstTab = allTabs.at(0);

		if (firstTab && !this.querySelector(":scope > chip-tab[selected]")) {
			firstTab.selected = true;
		}

		const content = document.createElementWithContents("div", null, { className: "tab-group__content" }),
			selectedIndex = allTabs.indexOf(this.GetSelectedTab()),
			actionContent = this.querySelectorAll(":scope > *:not(chip-tab)");

		allTabs.forEach((tab, index, self) => {
			const newTab = document.createElementWithContents("div",
				Array.from(tab.childNodes ?? []).filter(x => !x.closest?.("button.btn--tab, .tab__close-button")), { className: "tab-group__tab" });

			if (this.variation === "steps") {
				newTab.prepend(document.createElementWithContents("div",
					`
					<div class="mobile-header__title">Step ${index + 1} of ${self.length}</div>
					<div class="mobile-header__subtitle">${tab.getAttribute("label")}</div>
				`.trim(), {
					className: "tab__mobile-header"
				}));
			}

			content.appendChild(newTab);
		});

		this.appendChild(content);

		this.prepend(document.createElementWithContents("div", document.createElementWithContents("div", this.querySelectorAll(":scope > chip-tab"), { className: "tab__wrapper" }), {
			className: "tab-group__tabs"
		}));

		if (actionContent.length) {
			this.querySelector(".tab-group__tabs").appendChild(document.createElementWithContents("div", actionContent, { className: "nav__actions" }));
		}

		this.querySelector(`.tab-group__tab:nth-child(${selectedIndex + 1})`)?.classList.add("selected");
	}

	GetAllTabs() {
		return Array.from(this.querySelectorAll(":scope > chip-tab, :scope > .tab-group__tabs > .tab__wrapper > chip-tab"));
	}

  selectElement = element => {
    const content = element.closest(".tab-group__tab");

    this.selectIndex([...content.parentElement.children].indexOf(content));
  }

	GetSelectedContent = () => this.querySelector(`.tab-group__tab:nth-child(${this.selectedIndex + 1})`);
	selectIndex = index => this.querySelector(`chip-tab:nth-child(${index + 1})`).selected = true;

	GetSelectedTab = () => this.querySelector("chip-tab[selected]") ?? this.querySelector(`chip-tab:nth-child(${this.selectedIndex + 1})`) ?? this.querySelector("chip-tab");

	AddTab(label, content, options) {
		const tab = document.createElementWithContents("chip-tab", null, { label, ...options }),
			contentDiv = document.createElementWithContents("div", content, { className: "tab-group__tab" });

		this.querySelector("chip-tab:last-of-type")?.insertAdjacentElement("afterend", tab);
		this.querySelector(".tab-group__content")?.appendChild(contentDiv);

		tab.selected = true;

		if (this.querySelector(":scope > .tab-group__tabs > .tab__wrapper > chip-tab:not(:last-child)")) {
			this.querySelectorAll(":scope > .tab-group__tabs > .tab__wrapper > chip-tab").forEach(tab => {
				if (tab._allowClose) {
					tab.allowClose = true;
				}
			})
		}

		setTimeout(() => {
			const tabWrapper = this.querySelector(".tab-group__tabs");

			if (tabWrapper) {
				tabWrapper.scrollTo({
					left: tabWrapper.scrollWidth,
					behavior: 'smooth'
				});
			}
		}, 0);

		return tab;
	}
}
